export const COMPANY_BADGE_COLORS = [
  "#0f766e",
  "#1d4ed8",
  "#c2410c",
  "#9d174d",
  "#854d0e",
  "#4338ca",
  "#3f6212",
  "#1e3a8a",
  "#9a3412",
  "#44403c",
]

export const PUBLIC_BADGE_COLOR = "#0369a1"

export const TABLE_BADGE_STYLE = {
  color: "#fff",
  padding: "2px 4px",
  borderRadius: "4px",
  fontSize: "0.6rem",
  textAlign: "center",
  whiteSpace: "nowrap",
}

function hashSeed(value) {
  const str = String(value)
  let hash = 0
  for (let i = 0; i < str.length; i += 1) {
    hash = (hash * 31 + str.charCodeAt(i)) | 0
  }
  return Math.abs(hash)
}

export function getCompanyBadgeColor(company) {
  const seed =
    company?.id ||
    company?.createdAt ||
    company?.created_at ||
    company?.name ||
    ""

  if (!seed) return COMPANY_BADGE_COLORS[0]
  return COMPANY_BADGE_COLORS[hashSeed(seed) % COMPANY_BADGE_COLORS.length]
}

function isPublicPortalCompany(company) {
  if (company?.isPublic) return true
  const name = String(company?.name || "").trim().toLowerCase()
  return name === "public" || name === "public portal"
}

export function getPortalAccessBadge(user, companiesById) {
  const company = resolveUserCompany(user, companiesById)
  if (!company) return null

  if (isPublicPortalCompany(company)) {
    return {
      label: "Public",
      backgroundColor: PUBLIC_BADGE_COLOR,
      title: company.name || "Public",
    }
  }

  const name = company.name
  if (!name) return null

  return {
    label: name,
    backgroundColor: getCompanyBadgeColor(company),
    title: name,
  }
}

export function resolveUserCompany(user, companiesById) {
  const nested = user?.company
  const companyId = nested?.id || user?.companyId

  if (companyId && companiesById?.has?.(companyId)) {
    return { ...nested, ...companiesById.get(companyId) }
  }

  if (nested?.name || nested?.id) return nested

  const companyName = user?.companyName
  if (companyName && companiesById?.size) {
    for (const company of companiesById.values()) {
      if (company?.name === companyName) return company
    }
  }

  if (companyName) return { name: companyName }
  return null
}

export const MUST_READ_BADGE_COLOR = "#b45309"

export function getMustReadBadge(user) {
  const role = Number(user?.role)
  const summary = user?.mustRead
  if (![3, 4].includes(role) || !summary || !summary.total) return null
  if (summary.reviewed >= summary.total) return null
  return {
    label: `Onboarding ${summary.reviewed}/${summary.total}`,
    backgroundColor: MUST_READ_BADGE_COLOR,
    title: `${summary.reviewed} of ${summary.total} Onboarding resources reviewed`,
  }
}
